export const isNumberKey = (evt: KeyboardEvent): boolean => {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode !== 44 && charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) return false;

    return true;
};
